import React, { useEffect, useRef, useState } from 'react';
import { TbPencil } from 'react-icons/tb';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineAddCircle } from 'react-icons/md';
import { BiMinus, BiPlus } from 'react-icons/bi';
import CustomToast from '../../popovers/CustomToast';
import { Toaster, toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { addActivityKeywords, getActivityKeywords } from '../../../actions/activityActions';
import { ADD_PROMPTER_RESET } from '../../../constants/activityConstants';

const DesktopPrompter = ({ activityId }) => {
    const [inputFields, setInputFields] = useState([{ keyword: '' }]);
    const [wordsNumber, setWordsNumber] = useState(1);
    const [newWord, setNewWord] = useState('');
    const [editKeyword, setEditKeyword] = useState(0);
    const inputRef = useRef(null);
    const dispatch = useDispatch();

    const { addedPrompter, keywords, activityWordsNumber, loading } = useSelector(state => state.activity);

    useEffect(() => {
        if (editKeyword !== null) {
            inputRef?.current?.focus();
        }
    }, [editKeyword]);

    useEffect(() => {
        dispatch(getActivityKeywords(activityId));
        if (addedPrompter) {
            dispatch({ type: ADD_PROMPTER_RESET });
            dispatch(getActivityKeywords(activityId));
            showToast("Keywords saved successfully!");
            // navigate(`/${id}/${activityId}/update`);
        }
    }, [dispatch, addedPrompter, activityId]);

    useEffect(() => {
        if (keywords && keywords?.length) {
            setInputFields(keywords);
            setEditKeyword(100);
        } else {
            setInputFields([{ keyword: '' }]);
        }
        if (Number(activityWordsNumber?.wordsNumber) > 0) {
            setWordsNumber(activityWordsNumber?.wordsNumber);
        } else {
            setWordsNumber(1);
        }
    }, [keywords, activityWordsNumber]);

    useEffect(() => {
        if (wordsNumber > inputFields.length ) {
            setWordsNumber(inputFields.length)
        }
    }, [inputFields.length])

    const showToast = (info) => {
        toast.custom(<CustomToast info={info} />, {
            duration: 3000,
        });
    };

    const addFields = (e) => {
        e.preventDefault();
        if (!newWord) {
            return;
        }
        let newfield = { keyword: newWord };
        setInputFields([...inputFields, newfield]);
        setNewWord('');
    };

    const removeFields = (index) => {
        let data = [...inputFields];
        data.splice(index, 1);
        setInputFields(data);
    };

    const handleFormChange = (index, event) => {
        let data = [...inputFields];
        data[index][event.target.name] = event.target.value;
        setInputFields(data);
    };

    const handleSubmit = () => {
        if (!(inputFields.every(item => item.keyword))) {
            showToast("Please fill in all the blanks!");
            return;
        }
        if (wordsNumber > inputFields?.length) {
            showToast("The number entered here must be less than or equal to the total number of words.");
            return
        }
        const uniqueValues = new Set(inputFields.map(v => v.keyword));
        if (uniqueValues.size < inputFields.length) {
            // Duplicates found
            showToast("Duplicate keywords exist!");
            return;
        }
        const keywords = inputFields;
        dispatch(addActivityKeywords(activityId, wordsNumber, keywords));
    }

  return (
    <div className='w-full	py-4'>
        <Toaster position="bottom-center" />
        <p className='activityTypeCinfo px-4 pb-4'>
            Please add all keywords to be used as a prompter.
        </p>
        <div className='pb-4 border-t border-[#CBD2E080]'>
            {inputFields.map((input, index) =>
                <div key={index} className='w-full flex flex-row py-3 border-b border-[#CBD2E080] px-4'>
                    {editKeyword !== index ? 
                    <p className='w-3/4 prompterInputLabels'>{input.keyword}</p>:
                    <input className='w-3/4 border-b border-[#2d3648b3] outline-none prompterInputLabels' name='keyword' 
                        value={input.keyword} 
                        onChange={(event) => handleFormChange(index, event)}
                        ref={inputRef} />}
                    <div className='w-1/4 flex flex-row'>
                        <TbPencil className='w-1/2 cursor-pointer' onClick={() => setEditKeyword(index)} />
                        <RiDeleteBin6Line className='w-1/2 cursor-pointer' onClick={() => {removeFields(index); showToast('You have deleted a keyword!');}} />
                    </div>
                </div>
            )}
        </div>
        <div className="flex w-full py-4 bg-[#CBD2E0] mb-4">
            <form onSubmit={addFields} className='px-4 w-full flex justify-between gap-2'>
                <button><MdOutlineAddCircle type='submit' /></button>
                <input className='w-full createFormLabels outline-none bg-[#CBD2E0]' value={newWord} onChange={(e) => {setNewWord(e.target.value); setEditKeyword(100);}} placeholder='Add Prompter Keyword' />
            </form>
        </div>

        <div className='flex flex-row gap-4 justify-center mb-4'>
            <div className='bg-[#E1E5ED] rounded-xl p-2'>
                <p className='pb-3 prompterCardInfo'>You've Made</p>
                <div className='flex flex-row'>
                    <p className='w-1/2' translate="no">{inputFields.length}</p>
                    <p className='w-1/2 prompterCardInfo'>words</p>
                </div>
            </div>

            <div className='bg-[#E1E5ED] rounded-xl p-2 w-[198px] flex items-center flex-col'>
                <p className='prompterCardInfo'>Number of words at a time</p>
                <div className='w-[130px] flex cursor-pointer flex-row justify-between rounded-[41px] bg-white items-center px-2 py-1'>
                    <div onClick={() => (wordsNumber > 0 && setWordsNumber(wordsNumber - 1))} className={`w-[24px] h-[24px] rounded-full ${wordsNumber === 0 ? "bg-[#E0E5F1]" : "bg-[#7C8494]"} flex justify-center items-center`}>
                        <BiMinus className='text-white' />
                    </div>
                    <p>{wordsNumber}</p>
                    <div onClick={() => {if (wordsNumber === inputFields?.length) {
                        showToast("The number entered here must be less than or equal to the total number of words.");
                        return
                    } setWordsNumber(wordsNumber + 1)}} 
                    className={`w-[24px] h-[24px] rounded-full cursor-pointer ${wordsNumber === inputFields?.length ? "bg-[#E0E5F1]" : "bg-[#7C8494]"} flex justify-center items-center`}>
                        <BiPlus className='text-white' />
                    </div>
                </div>
            </div>
        </div>
        
        <div className="mb-4 px-4 flex flex-col w-full items-center">
            <button className='py-1 px-8 mb-3 bg-[#CBD2E0] rounded-[20px]' onClick={handleSubmit}>
                {loading &&
                <svg role="status" className="inline mr-1 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                </svg>}
                Save
            </button>
            {/* <Link className='flex justify-center items-center py-1 px-8 border rounded-[20px]'>Cancel</Link> */}
        </div>
    </div>
  )
}

export default DesktopPrompter